import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom-v5-compat";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
  type AppDispatch,
} from "@b2bportal/core-types";
import { ListError } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HotelListError.module.scss";
import { PackageSearchSelectors } from "@/store/packages/selectors";
import { initializePackages } from "@/store/packages/thunks";

/**
 * Override of HotelListError for packages.
 * When user clicks reload, this triggers the packages requisition flow
 * instead of the standard hotels fetch.
 */
export const HotelListError = ({
  className,
  children,
}: PlatformComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelListError;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const requestedSearch = useSelector(
    PackageSearchSelectors.getRequestedSearch
  );

  const handleReload = () => {
    if (requestedSearch != null) {
      // Re-initialize packages with the current search parameters
      // This will trigger the requisition flow and properly fetch package prices
      dispatch(
        initializePackages({
          search: {
            origin: requestedSearch.origin.label,
            destination: requestedSearch.destination.label,
            fromDate: requestedSearch.dateRange.from,
            untilDate: requestedSearch.dateRange.until,
            adults: requestedSearch.guests.adultCount,
            children: requestedSearch.guests.childAges,
            packageType: requestedSearch.packageType,
            driverAge: requestedSearch.driverAge,
            roomCount: requestedSearch.roomCount,
          },
        })
      );
    } else {
      // Fallback: reload the page if search state is unavailable
      navigate(0);
    }
  };

  return (
    <ListError className={clsx(block, className)} onTapReload={handleReload}>
      {children}
    </ListError>
  );
};
